import { toast } from "react-toastify";

import { clearUserCookie } from "lib/userCookie";

// Calls that may come back 401 without sending the student to the login:
// App asks /me on every load, and a wrong password is answered on the form.
const QUIET = ["/me", "/auth/login"];

export default function errorHandler(error) {
  const response = error?.response;
  if (!response) return Promise.reject(error);

  const url = error.config?.url ?? "";
  if (response.status === 401) {
    if (!QUIET.some((path) => url.endsWith(path))) {
      // The session ended (signed out elsewhere or expired): sign in again
      // and come back to this page.
      clearUserCookie();
      const here = window.location.pathname.replace(process.env.PUBLIC_URL || "", "") || "/";
      window.location.href = `${process.env.PUBLIC_URL}/login?path=${encodeURIComponent(here)}`;
    }
    return Promise.reject(error);
  }

  const message =
    response.status >= 500 ? "Something went terribly wrong" : response.data?.message;
  if (typeof message === "string") toast.error(message);
  return Promise.reject(error);
}
